<template>
  <div class="wrapper-tags">
    <nuxt-link
      v-for="(days, i) in durations"
      :key="i"
      :to="`/search?type=country&value=${country.permalink}&duration=${days}&duration=${days}`"
      class="el-tag el-tag--medium el-tag--light"
      @click.native="handleLoading"
      >{{ $t(`${base}.tags.label`, { days }) }}</nuxt-link
    >
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchTagsFilters',
  data() {
    return {
      base: 'search.country.tours',
      durations: [7, 15, 21],
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({
        permalink: state.header.permalink.default,
      }),
    }),
  },
}
</script>

<style lang="scss">
.wrapper-tags {
  margin-bottom: 40px;

  .el-tag {
    border-color: rgba(64, 158, 255, 1);
    border-radius: 20px;
    cursor: pointer;

    & + .el-tag {
      margin-left: 5px;
    }

    &:hover {
      color: rgb(19, 79, 140);
    }
  }
}
</style>
